import styled, {css} from "styled-components"
import {getTopPos, getLeftPos} from "../helpers/position"

const MultiplePicturesWrapper = styled.div`
  ${({theme, ...otherProps}) => css`
    position: absolute;
    ${otherProps.horizontal
      ? css`
          left: ${getLeftPos(otherProps)}px;
        `
      : css`
          top: ${otherProps.offset || getTopPos(otherProps)}px;
          left: ${otherProps.offset || getLeftPos(otherProps)}px;
        `}
    border: ${otherProps.multiplePictureSize >= 100 ? "4px" : "3px"} solid ${theme.colors.utility.white};
    border-radius: 50%;
    background-color: ${theme.colors.utility.white};
  `}
`

export default MultiplePicturesWrapper
